import { render, staticRenderFns } from "./MobilePhones.vue?vue&type=template&id=30f03304&"
import script from "./MobilePhones.vue?vue&type=script&lang=js&"
export * from "./MobilePhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports